/*
==========================================
STAMP CUSTOMIZER  v4.0.3
文件: assets/stamp-customizer.js

v4.0.3 改动（基于 v4.0.2 最小改动）：
- waitForDeps() 新增对 body-template layout 的判断：
  body-template 时额外等待 StampPhotoEditor（同 address-label 策略）
- 其余所有代码与 v4.0.2 完全一致

v4.0.2（保留）：
- waitForDeps() 新增 layout 参数
- address-label 时额外等待 StampAddressComposer

!! 加新产品不要改这个文件 !!
!! 产品配置在 product.metafields.custom.stamp_config 里设置 !!
==========================================
*/
(function () {
  'use strict';

  // ★ v4.0.3：body-template 和 address-label 都需要额外等待各自的 composer
  //            两者都需要等待 StampPhotoEditor
  function waitForDeps(layout, callback, timeout) {
    const start = Date.now();
    timeout = timeout || 8000;

    function check() {
      const coreReady = typeof window.StampCore !== 'undefined' &&
                        typeof window.StampUI   !== 'undefined';

      // ★ v4.0.3：需要 StampPhotoEditor 的 layout
      const needsPhotoEditor = layout === 'address-label' || layout === 'body-template';
      const photoEditorReady = !needsPhotoEditor ||
                               typeof window.StampPhotoEditor !== 'undefined';

      // address-label 额外等 StampAddressComposer
      const composerReady = layout !== 'address-label' ||
                            typeof window.StampAddressComposer !== 'undefined';

      if (coreReady && photoEditorReady && composerReady) { callback(); return; }

      if (Date.now() - start > timeout) {
        console.error('[StampCustomizer] Timeout waiting for dependencies. layout:', layout,
          { StampCore: !!window.StampCore, StampUI: !!window.StampUI,
            StampPhotoEditor: !!window.StampPhotoEditor,
            StampAddressComposer: !!window.StampAddressComposer });
        return;
      }
      setTimeout(check, 50);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', check);
    } else {
      check();
    }
  }

  // 提前读取 layout 供 waitForDeps 判断
  const _layout = JSON.parse(document.getElementById('prodStampConfig')?.textContent || '{}').layout || '';

  waitForDeps(_layout, function () {

    const configEl  = document.getElementById('prodStampConfig');
    const variantEl = document.getElementById('prodVariantData');
    if (!configEl || !variantEl) {
      console.error('[StampCustomizer] config or variant data not found');
      return;
    }

    const config   = JSON.parse(configEl.textContent);
    const variants = JSON.parse(variantEl.textContent);

    const credentials = {
      emailjsPublicKey:    '-0ipkIIMt0nCaHlrI',
      emailjsServiceId:    'uskcbuy',
      emailjsTemplateId:   'template_wb5jebb',
      sellerEmail:         'uskcbuy@gmail.com',
      cloudinaryCloudName: 'dvalm8qtq',
      cloudinaryPreset:    'bvugco4w',
      removebgKey:         'YOUR_REMOVEBG_API_KEY'
    };

    // address-label 走独立路径
    if (config.layout === 'address-label') {
      StampAddressComposer.initUI(config, variants, credentials);
      return;
    }

    // 其余所有 layout（含 body-template）走通用路径
    StampUI.init(config, variants, credentials);

  });

})();